import { render, staticRenderFns } from "./ConfigurationDetailsModal.vue?vue&type=template&id=3d6d0f8f"
import script from "./ConfigurationDetailsModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports